import { createFileRoute } from "@tanstack/react-router";
import { FromTextRecipePage } from "./-FromTextRecipePage";

export const Route = createFileRoute("/_app/_recipe-page/recipes/from-text")({
  component: FromTextRecipePage,
});
